import React from "react";
import { Container } from "semantic-ui-react";
import { ListPost } from "../../../components/Web/Blog";

export function Blog() {
  return (
    <Container>
      <ListPost />
    </Container>
  );
}
